import React, { FC, useCallback, useMemo } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isSupplierInventoryConfigEnabled } from '../common/SupplierInventoryConfigPermissionChecker';
import { CONFIG_NAMES } from '../../utils/AuthUtils';
import OverviewShell from '../overview_shell/OverviewShell';

const DepreciationOverviewPage: FC<any> = ({
	history,
	companyConfig,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => {
			history.push(`/supplier/depreciation/overview/${key}`);
		},
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const exchangeRateEnabled = useMemo(
		() =>
			isSupplierInventoryConfigEnabled(
				companyConfig,
				CONFIG_NAMES.ALLOW_MONTHLY_CURRENCY_EXCHANGE_RATE
			),
		[companyConfig]
	);

	const tabs = useMemo(
		() => [
			{
				key: 'depreciationClass',
				name: 'Depreciation Classes',
			},
			{
				key: 'impairment',
				name: 'Impairments',
			},
			{
				key: 'burdenRates',
				name: 'Burden Rates',
			},
			{
				key: 'journalRuns',
				name: 'Journal Runs',
			},
			{
				key: 'taxRates',
				name: 'Tax Rates',
			},
			...(exchangeRateEnabled
				? [
						{
							key: 'exchangeRates',
							name: 'Exchange Rates',
						},
				  ]
				: []),
		],
		[exchangeRateEnabled]
	);

	return (
		<>
			<Route
				path="/supplier/depreciation/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/depreciation/overview/depreciationClass',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Accounting"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
});

export default withRouter<any, any>(connect(mapStateToProps)(DepreciationOverviewPage));
